<template>
    <div class="flex-con xs-pad-lr">
        <div
            class="tooltip is-tooltip-bottom"
            :data-tooltip="status.text"
        >
            <i
                v-if="!status.isPartial"
                class="fa fa-archive"
                :style="{ color : status.color }"
                :class="status.className"
            ></i>
            <multi-color-icon
                v-else
                icon-class="fa-archive"
                :left-class="status.leftClass"
                :right-class="status.rightClass"
            >
            </multi-color-icon>
        </div>
        <div
            v-if="includeText"
            class="status-text"
        >
            {{status.text}}
        </div>
    </div>
</template>

<script>
import StatusUtil from "../../util/StatusUtil";
import MultiColorIcon from '../../elements/MultiColoredIcon';

export default {
    name : "PurchaseOrderProgressIcon",
    components : {
        MultiColorIcon,
    },
    props : {
        processStatusId : {
            type : Number,
            required : true,
        },
        failedStatusId : {
            type : Number,
            required : true,
        },
        canceledStatusId : {
            type : Number,
            required : true,
        },
        voidedStatusId : {
            type : Number,
            required : true,
        },
        includeText : {
            type : Boolean,
            required : false,
            default : false,
        },
    },
    computed : {
        status () {
            if(this.failedStatusId === StatusUtil.COMPLETION.FULLY.id) {
                return {
                    text : 'Failed To Process',
                    className : 'status-color-bad',
                };
            }
            if(this.voidedStatusId === StatusUtil.COMPLETION.FULLY.id) {
                return {
                    text : 'Voided',
                    className : 'status-color-warning',
                };
            }
            if(this.canceledStatusId === StatusUtil.COMPLETION.FULLY.id) {
                return {
                    text : 'Canceled',
                    className : 'status-color-warning',
                };
            }

            let contexts = [];

            if(this.failedStatusId === StatusUtil.COMPLETION.PARTIALLY.id) {
                contexts.push({
                    text : 'Partially Failing',
                    className : 'status-color-bad',
                });
            }
            if(this.canceledStatusId === StatusUtil.COMPLETION.PARTIALLY.id) {
                contexts.push({
                    text : 'Partially Canceled',
                    className : 'status-color-warning',
                });
            }
            if(this.voidedStatusId === StatusUtil.COMPLETION.PARTIALLY.id) {
                contexts.push({
                    text : 'Partially Voided',
                    className : 'status-color-warning',
                });
            }

            let process = null;

            if(this.processStatusId === StatusUtil.COMPLETION.FULLY.id) {
                process = {
                    text : 'Fully Processed',
                    className : 'status-color-3',
                };
            } else if(this.processStatusId === StatusUtil.COMPLETION.PARTIALLY.id) {
                process = {
                    text : 'Partially Processed',
                    className : 'status-color-2',
                };
            } else {
                process = {
                    text : 'Unprocessed',
                    className : 'status-color-1',
                };
            }

            var texts = [process.text].concat(contexts.map(c => c.text));

            if(contexts.length) {
                return {
                    isPartial : true,
                    text : texts.join(' & '),
                    leftClass : process.className,
                    rightClass : contexts.length > 1 ?  'status-color-bad' : contexts[0].className,
                };
            }

            return process;

        },
    },
}
</script>
